import React from 'react';
import AbroadTooltip from '../../CellcomAbroadLobbyBlock/Shared/Components/Tooltip/AbroadTooltip';
const PackageHeading = ({text, tooltipId="", onclick, tooltipText =""}) => {
  return (
    <div className='PackageHeader'>
      <p className='Heading'>
        {text} <AbroadTooltip tooltipId={tooltipId} onclick={onclick} tooltipText={tooltipText} isFromAbroadDataUsage={true} />
      </p>
    </div>
  );
};

export default PackageHeading;
